import { TicketItemGroupType } from "@shared/modules/item-groups/types/ticket-item-group-type";

export const hasSeating = (itemGroup: TicketItemGroupType) =>
  [...(itemGroup.permissions || []), ...(itemGroup.location_permissions || [])]
    .length > 0;
